<template>
  <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper" id="kt_wrapper">
    <div class="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
         id="kt_content">
      <div class="kt-container ">
        <h3
          class="kt-sc__heading kt-heading kt-heading--center kt-heading--xxl kt-heading--medium">
          Обращение в Общий Центр Обслуживания
        </h3>
        <div class="row">
          <div class="col-lg-4">
            <ActionBox
              :icon="'fa fa-plus-circle'"
              :name="'Отправить заявку'"
              :description="'Отправить заявку в сервис деск'"
              :route="'service.request'"
              :speed="'slow'"/>
          </div>
          <div class="col-lg-4">
            <ActionBoxLink
              :icon="'tablet'"
              :name="'Заказать пропуск'"
              :description="'Оформление нового пропуска'"
              :mobile="'https://may-work.com/mobile/laissez-passer.php?ELEMENT_ID=0'"
              :full="'https://may-work.com/laissez-passer.php?ELEMENT_ID=0'"
              :speed="'normal'"/>
          </div>
          <div class="col-lg-4">
            <ActionBox
              :icon="'user'"
              :name="'Оформить сотрудника'"
              :description="'В разработке'"
              :route="'under.construction'"
              :speed="'fast'"/>
          </div>
        </div>

        <hr>
        <h3
          class="kt-sc__heading kt-heading kt-heading--center kt-heading--xxl kt-heading--medium">
          Мои обращения
        </h3>

        <div class="row">
          <div class="col-lg-4">
            <ActionBox
              :icon="'fa fa-plus-circle'"
              :name="'Обращения в сервис деск'"
              :description="'Ваши заявки и подписки'"
              :route="'service.list'"
              :speed="'normal'"/>
          </div>
          <div class="col-lg-4">
            <ActionBoxLink
              :icon="'tablet'"
              :name="'Список пропусков'"
              :description="'Заказанные пропуска'"
              :mobile="'https://may-work.com/mobile/laissez-passer.php'"
              :full="'https://may-work.com/laissez-passer.php'"
              :speed="'normal'"/>
          </div>
        </div>


        <template v-if="isAdmin">
          <hr>
          <h3
            class="kt-sc__heading kt-heading kt-heading--center kt-heading--xxl kt-heading--medium">
            Настройки
          </h3>

          <div class="row">
            <div class="col-lg-4">
              <ActionBox
                :icon="'flaticon2-gear'"
                :name="'Настройки приложения'"
                :description="'Управление приложением'"
                :route="'settings.app'"
                :speed="'fast'"/>
            </div>
          </div>
        </template>
      </div>
    </div>
    <!--[html-partial:include:{"file":"partials\/_footer-base.html"}]/-->
  </div>
</template>

<script>
// @ is an alias to /src
import ActionBox from '../components/ActionBox.vue';
import ActionBoxLink from '../components/ActionBoxLink.vue';

export default {
  name: 'Home',
  computed: {
    isAdmin() {
      return this.$root.app_data.is_admin;
    },
  },
  components: {
    ActionBox,
      ActionBoxLink,
  },
};
</script>
